import { MapPin } from 'lucide-react'
import { splitWithAddresses, mapsUrl } from '../utils/addressUtils'

// Renderizza il testo sostituendo eventuali indirizzi con link cliccabili
// che aprono Google Maps in una nuova scheda.
// Preserva i newline (white-space: pre-wrap sul wrapper) se il parent non li gestisce.
// Usage:
//   <LinkifiedText text={task.notes} />
//   <LinkifiedText text={task.notes} className="..." />
export default function LinkifiedText({ text, className, as: Tag = 'span' }) {
  if (!text) return null
  const segments = splitWithAddresses(text)

  // Fast path: nessun indirizzo → rendi solo testo
  if (segments.length === 1 && !segments[0].address) {
    return <Tag className={className}>{text}</Tag>
  }

  return (
    <Tag className={className}>
      {segments.map((seg, i) =>
        seg.address ? (
          <a
            key={i}
            href={mapsUrl(seg.address)}
            target="_blank"
            rel="noopener noreferrer"
            className="address-link"
            onClick={e => e.stopPropagation()}
            title={`Apri in Google Maps: ${seg.address}`}
          >
            <MapPin size={12} className="address-link-icon" />
            {seg.text}
          </a>
        ) : (
          <span key={i}>{seg.text}</span>
        )
      )}
    </Tag>
  )
}
